<template lang="pug">
  transition(name="fade")
    .v-dialog(
      tabindex="0"
      v-if="value"
      @keydown.esc="closeDialog")
      .v-dialog__scroll
        vue-scroll
          .v-dialog__inner(
            @mouseup="onMouseUp"
            @mousedown.self="isMouseDownOutside = true")
            .v-dialog__content(
              :style="{ 'max-width': `${maxWidth}px` }")
              button.v-dialog-close(@click="closeDialog")
                i.i-util-close
              slot
</template>

<script>
import escapableMixin from '@/mixins/escapable.mixin.js'

export default {
  name: 'VDialog',

  mixins: [escapableMixin],

  props: {
    value: Boolean,
    maxWidth: [Number, String]
  },

  data: () => ({
    isMouseDownOutside: false
  }),

  methods: {
    closeDialog () {
      this.$emit('input', false)
    },

    escapeHandler () {
      this.closeDialog()
    },

    onMouseUp () {
      if (this.isMouseDownOutside) {
        this.closeDialog()
      }
      this.isMouseDownOutside = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_variables.scss';

  .v-dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background-color: rgba(63, 92, 102, 0.35);
    overflow-y: auto;

    &__scroll {
      height: 100vh;
      width: 100%;
    }

    &__content {
      position: relative;
      width: 100%;
    }

    &__inner {
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4rem 2rem;
      z-index: 1000;
    }
  }

  .v-dialog-close {
    cursor: pointer;
    display: inline-flex;
    position: absolute;
    z-index: 5;
    top: 1rem;
    right: 1rem;
    width: 3.6rem;
    height: 3.6rem;
    border-radius:1rem;
    background-color: #EEEEEE;
    transition: .3s linear;

    &:hover {
      background-color: #F6DCDC;
    }

    &:active {
      background-color: #F6DCDC;
    }

    &:focus {
      outline: none;
    }

    i {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(.6);
    }
  }
</style>
